import script from "./formato.vue?vue&type=script&setup=true&lang=js"
export * from "./formato.vue?vue&type=script&setup=true&lang=js"

import "./formato.vue?vue&type=style&index=0&id=9d70d94a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d70d94a"]])

export default __exports__